import { Register } from './router'

const PartnerModule = () => {
	const partner = require(/* webpackChunkName: "partner" */ '../modules/private/partner')
	Register('partner', partner)
	return partner
}

const PartnerTicketsSalesReportModule = () => {
	const partnerpurchasedtickets = require(/* webpackChunkName: "partnerpurchasedtickets" */ '../modules/private/partner/tickets-sales-report')
	Register('partnerPurchasedTickets', partnerpurchasedtickets)
	return partnerpurchasedtickets
}

const PartnerPointsExtractModule = () => {
	const partnerpointsextract = require(/* webpackChunkName: "partnerpointsextract" */ '../modules/private/partner/points-extract')
	Register('partnerPointsExtract', partnerpointsextract)
	return partnerpointsextract
}

export {
	PartnerModule,
	PartnerTicketsSalesReportModule,
	PartnerPointsExtractModule
}
